import { Component, OnInit, Input} from '@angular/core';

// env
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-widget-image-detail',
  templateUrl: './widget-image-detail.component.html',
  styles: [
  ]
})
export class WidgetImageDetailComponent implements OnInit {
  
  @Input() dataWidgetDet;
  @Input() order = '1';
  apiAsset = environment.API_ASSETS;
  
  constructor() { }

  ngOnInit(): void {
  }

}
